module.exports = __webpack_public_path__ + "static/media/Slice3.c7d3489b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_174/img/Slice3.png
// module id = 1606
// module chunks = 0